import React from 'react'
import usePagination, { UsePaginationItem, UsePaginationProps } from '@mui/material/usePagination'
import { JourneeButton } from '../JourneeButton'
import { useMediaQuery } from '../../../hooks'
import styles from './styles.module.scss'
import clsx from 'clsx'

const ICON_CLASS_MAPPING: { [x in UsePaginationItem['type']]?: string } = {
    previous: 'fi-rs-angle-small-left',
    next: 'fi-rs-angle-small-right',
}

const ICON_BUTTON_TITLE: { [x in UsePaginationItem['type']]?: string } = {
    previous: 'Journée précédente',
    next: 'Journée suivante',
}

// todo: types
const SIBLING_COUNT = {
    mobile: 1,
    tablet: 2,
    desktop: 5,
    largeDesktop: 7,
}

// todo: types
const BOUONDARY_COUNT = {
    mobile: 0,
    tablet: 1,
    desktop: 1,
    largeDesktop: 1,
}

type JourneePaginatorProps = {
    pageCount: number
    page: number
    onChange: UsePaginationProps['onChange']
    /**
     * labels[n] = label of page n
     */
    labels: string[]
    loadingPage: number | null
}

export const JourneePaginator = ({
    pageCount,
    page,
    onChange,
    labels,
    loadingPage,
}: JourneePaginatorProps) => {
    // todo: hook with types
    const isLargeDesktopUp = !useMediaQuery('(max-width: 1250px)')
    const isDesktopUp = !useMediaQuery('(max-width: 1030px)')
    const isTabletUp = !useMediaQuery('(max-width: 660px)')
    const screenSize = isLargeDesktopUp
        ? 'largeDesktop'
        : isDesktopUp
        ? 'desktop'
        : isTabletUp
        ? 'tablet'
        : 'mobile'

    const { items } = usePagination({
        count: pageCount,
        page,
        onChange,
        siblingCount: SIBLING_COUNT[screenSize],
        boundaryCount: BOUONDARY_COUNT[screenSize],
    })

    return (
        <div className={styles.pagination}>
            {items.map(({ page, type, selected, ...item }, index) => {
                if (type === 'start-ellipsis' || type === 'end-ellipsis') {
                    return (
                        <span key={index} className={styles.ellipsis}>
                            ...
                        </span>
                    )
                }

                if (type === 'first' || type === 'last' || type === 'previous' || type === 'next') {
                    return (
                        <button
                            key={index}
                            {...item}
                            className={styles.iconButton}
                            title={ICON_BUTTON_TITLE[type]}
                        >
                            <i className={clsx(`fi ${ICON_CLASS_MAPPING[type]}`, styles.icon)}></i>
                        </button>
                    )
                }

                return (
                    <JourneeButton
                        key={page !== null ? labels[page] : index}
                        selected={selected}
                        loading={loadingPage === page}
                        onClick={item.onClick}
                    >
                        {page !== null ? labels[page] ?? '' : ''}
                    </JourneeButton>
                )
            })}
        </div>
    )
}
